import React from 'react';

interface IChatDataProps {
  chatText: string;
}

/**
 * 채팅 데이터 컴포넌트
 */
const ChatData = ({chatText}: IChatDataProps) => {
  return (
    <div
      className='chatting-list-item'
      dangerouslySetInnerHTML={{__html: chatText}}></div>
  );
};

export default ChatData;
